import { render, staticRenderFns } from "./ItemManagePage.vue?vue&type=template&id=049d3160&scoped=true"
import script from "./ItemManagePage.vue?vue&type=script&lang=js"
export * from "./ItemManagePage.vue?vue&type=script&lang=js"
import style0 from "./ItemManagePage.vue?vue&type=style&index=0&id=049d3160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049d3160",
  null
  
)

export default component.exports